import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '@vectord/components';

import {
  BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES,
  removeSuperBatchesModalStageSelector,
  setRemoveSuperBatchesModalStage,
} from 'features/classCreation';
import BulkRemoveSuperBatchesModalStageRenderer from '../BulkRemoveSuperBatchesModalStageRenderer';
import styles from './BulkRemoveSuperBatchesModal.module.scss';

export default function BulkRemoveSuperBatchesModal() {
  const dispatch = useDispatch();
  const modalStage = useSelector(removeSuperBatchesModalStageSelector);
  const isOpen = modalStage !== BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES.notOpen;

  const handleModalClose = useCallback(() => {
    dispatch(
      setRemoveSuperBatchesModalStage(
        BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES.notOpen
      )
    );
  }, [dispatch]);

  return (
    <Modal
      isOpen={isOpen}
      withoutHeader
      onClose={handleModalClose}
      unMountOnClose
      className={styles.root}
      size="large"
    >
      <BulkRemoveSuperBatchesModalStageRenderer />
    </Modal>
  );
}
